import { Button, ButtonGroup, Flex, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon, RefreshIcon } from "../icons";

const i18prefix = "shared:error";

interface Props {
  errorCode: number;
  goBackUrl?: string;
}

export const ErrorScreen: React.FC<Props> = ({ errorCode, goBackUrl }) => {
  const navigate = useNavigate();

  return (
    <Flex
      height="100%"
      width="100%"
      position="absolute"
      top={0}
      left={0}
      justifyContent="center"
      alignItems="center"
    >
      <VStack gap={4}>
        <Text textAlign="center" maxWidth="300px" fontSize="2xl">
          {t(`${i18prefix}.${errorCode}`)}
        </Text>
        <ButtonGroup colorPalette="primary">
          {!!goBackUrl && (
            <Button onClick={() => navigate(goBackUrl)}>
              <ArrowBackIcon /> {t(`${i18prefix}.back`)}
            </Button>
          )}
          <Button onClick={() => window.location.reload()}>
            <RefreshIcon /> {t(`${i18prefix}.refresh`)}
          </Button>
        </ButtonGroup>
      </VStack>
    </Flex>
  );
};
